<template>
  <div>
    <p class="title text-left">及时雨四周年庆：吃的很好，玩得很嗨！</p>
    <p class="desc text-left">2017-3-9　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">春暖花开，绿意盎然。3月8号下午，上海及时雨小贷现身大批绿衣人......在吃喝玩乐！你说是庆祝三八节？男生也在其中不亦乐乎~到底发生了什么？</p>
      <div class="normal"><img src="../img/newsDetail/6-01.png" width="100%" alt=""></div>
      <p class="normal">原来，昨天竟是及时雨四周年庆典！及时雨成立的4年来，不断积聚能量，不断成长，所有及时雨人共同努力成就今日的“绿意盎然”！</p>
      <p class="bold"><span>及时雨四周年庆&三八仙女节</span></p>
      <div class="normal"><img src="../img/newsDetail/6-02.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-03.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-04.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-05.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-06.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-07.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-08.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-09.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-10.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-11.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-12.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-13.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-14.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-15.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-16.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-17.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-18.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/6-19.png" width="100%" alt=""></div>
      <p class="normal">欢乐的时光总是稍纵即逝，四年点滴感谢有你，所有及时雨人，我们将继续不忘初心，继续前进！</p>
      <div class="normal"><img src="../img/newsDetail/6-20.png" width="100%" alt=""></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail6"
  }
</script>

<style scoped lang="less">
  @import "newsDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail6.vue